import React, { useEffect, useState } from 'react';

export default function Loader() {
    const [visible, setVisible] = useState(true);
    const [fading, setFading] = useState(false);

    useEffect(() => {
        const fadeTimer = setTimeout(() => setFading(true), 1000); // Start fade after 1 second
        const hideTimer = setTimeout(() => setVisible(false), 2500); // Fully hide after fade

        return () => {
            clearTimeout(fadeTimer);
            clearTimeout(hideTimer);
        };
    }, []);

    if (!visible) return null;

    return (
        <div
            className={`fixed top-0 left-0 w-screen h-screen overflow-hidden bg-black bg-opacity-90 backdrop-blur-sm flex flex-col items-center justify-center text-white z-[9999] transition-opacity duration-1000 ${
                fading ? 'opacity-0' : 'opacity-100'
            }`}
        >
            <img 
                src="/assets/others/ChatGPT Image Apr 29, 2025, 03_40_21 PM.png" 
                className="w-25 h-25 mb-6 animate-spin-glow" 
                alt="Loading spinner" 
            />
            <p className="text-xl font-semibold animate-pulse">Loading...</p>
            <style jsx>{`
                 @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes glow {
    0%, 100% {
      box-shadow: 0 0 10px 2px rgba(255, 255, 255, 0.4);
    }
    50% {
      box-shadow: 0 0 20px 4px rgba(255, 255, 255, 0.8);
    }
  }

  .animate-spin-glow {
    animation: glow 1.5s ease-in-out infinite;
    border-radius: 9999px;
    padding:10px;
  }
                `
                
                }

            </style>
        </div>
    );
}
